import * as types from '@/store/types';
import Axios from 'axios';

export default {
  async sendContact({}, {contact}){
    try{
      await Axios.post('/api/web/contact_us', contact);
      return true;
    }catch(error){
      return error
    }
  }
};
